import { render, staticRenderFns } from "./HostGuestMessages.vue?vue&type=template&id=c6965da4&scoped=true"
import script from "./HostGuestMessages.vue?vue&type=script&lang=js"
export * from "./HostGuestMessages.vue?vue&type=script&lang=js"
import style0 from "./HostGuestMessages.vue?vue&type=style&index=0&id=c6965da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6965da4",
  null
  
)

export default component.exports